module.exports = __webpack_public_path__ + "img/finger.6ff62c88.svg";